import React from "react";

function Footer() {
  const date = new Date();
  const year = date.getFullYear();
  return (
    <div className="footer">
      <a href="https://www.weborama.nl" target="_blank" rel="noreferrer">
        Weborama
      </a>{" "}
      Nederland &copy; {year}
    </div>
  );
}

export default Footer;
